import React, { useEffect, useState } from "react";
import { Box, Rating as MuiRating, Typography } from "@mui/material";
import { useTranslation } from 'react-i18next';
import env from "../../app/config/envHelper";
import { useWindowSize } from "../hooks/useWindowSize";

export default function Rating({ rating }) {

    const { t } = useTranslation();
    // const [rating, setRating] = useState({rating: 3.5, totalRatings: 50});
    const [loading, setLoading] = useState(false);
    const { isMobile } = useWindowSize();

    while (loading) {
        return null;
    }

    if (!rating || typeof rating?.rating !== "number") {
        return (
            <Box display="flex" alignItems="center">
                <Typography variant="body2" color="text.secondary">
                    {t('rating.noRatings')}
                </Typography>
            </Box>
        );
    }

    return (
        <Box display="flex" alignItems="center">
            <Typography variant="body1" fontWeight="bold" mr={1} sx={{ fontSize: isMobile ? '0.75rem' : '1rem' }}>
                {rating?.rating.toFixed(1)}
            </Typography>
            <MuiRating
                name="read-only-rating"
                value={rating?.rating}
                precision={0.5}
                readOnly
                size="small"
            />
            {rating?.userRatingCount > 0 && (
                <Typography variant="body2" color="text.secondary" ml={1} sx={{ fontSize: isMobile ? '0.75rem' : '1rem' }}>
                    ({rating.userRatingCount})
                </Typography>
            )}
        </Box>
    );
}
